//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uninsuredInfo } from '@/model/javaApi/present.js'
import axios from 'axios';
import  TipSwipper  from './components/TipSwipper.vue'

export default {
    data(){
        return{
            gainNo:'',
            gainInfo:[],
            topIMG:"https://static.soyoung.com/sy-pre/1@3x-1617271800694.png",
            centerIMG:"https://static.soyoung.com/sy-pre/2@3x-1617271800694.png",
            buyFlag:true, //是否可以领取
        }
    },
    computed:{
        count(){
            return this.gainNo.split('');
        },
         // 渠道商品code
        channelCommodityCode(){
            return this.$route.query.channelCommodityCode
        },
        baseNo(){
            return this.$route.query.baseNo ||''
        }
    },
    created(){
        this.STATISTICS_CONFIG.insur_proinfo_page();
        this.getInfo();
        this.getStatic();
        // 禁用分享
        this.AppSetTitleBar('安心美',["refresh"]);
    },
    methods:{
        getInfo(){
            // 获取未投保页信息
            uninsuredInfo({'channelCommodityCode':this.channelCommodityCode,'baseNo':this.baseNo}).then(res =>{
                this.gainInfo=res.gainInfo;
                this.gainNo = res.gainNo.toString() || '0';
                if(!res.buyFlag){
                    this.buyFlag = false
                    this.$toast("当前订单状态不支持保险领取"); 
                }
            })
        },
        // 获取图片
        getStatic(){
            let code = this.channelCommodityCode.toLowerCase()
            const url = 'https://static.soyoung.com/sy-pre/' + code +'-1619428200787.json'

            axios.get(url).then((res) => {
                console.log(res)
                let data = res.data;
                this.topIMG = data.primary.topIMG
                this.centerIMG = data.primary.centerIMG
            })
        },
        btnClick(){
            this.STATISTICS_CONFIG.insur_proinfo_submit2_click();
            if(this.buyFlag){
                this.$router.push({
                    path: "/attachPresent",
                    query:{
                        channelCommodityCode:this.channelCommodityCode,
                        origin:'presentOrderDetail',
                        baseNo:this.baseNo,
                        flag:'postdisable'
                    }
                });
            }else{
                this.$toast("当前订单状态不支持保险领取"); 
            }
            
        }
    },
    components:{
        TipSwipper
    }
}
